var map = {
	"./404/ErrorPage": "fTQd",
	"./404/ErrorPage.vue": "fTQd",
	"./Home": "j7e0",
	"./Home.vue": "j7e0",
	"./frame/Footer": "V6YO",
	"./frame/Footer.vue": "V6YO",
	"./frame/GoBack": "R0pV",
	"./frame/GoBack.vue": "R0pV",
	"./frame/Header": "m23R",
	"./frame/Header.vue": "m23R",
	"./product/IntelligentWarehousing": "TG6q",
	"./product/IntelligentWarehousing.vue": "TG6q",
	"./product/Logistics": "t5OW",
	"./product/Logistics.vue": "t5OW",
	"./product/NetworkFreight": "o8p5",
	"./product/NetworkFreight.vue": "o8p5",
	"./public/AboutUs": "crRX",
	"./public/AboutUs.vue": "crRX",
	"./public/Customers": "VSNQ",
	"./public/Customers.vue": "VSNQ",
	"./public/Recruitment": "Oqec",
	"./public/Recruitment.vue": "Oqec"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g9CB";


//////////////////
// WEBPACK FOOTER
// ./src/views ^\.\/.*$
// module id = g9CB
// module chunks = 1